function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg viewBox="0 0 26 26" width="24" height="24" {...props}><path d="M16 0a6.7 6.7 0 0 0-5.31 2.4A8.64 8.64 0 0 0 9 7.9V9h3V7.9c0-1.57.4-2.81 1.03-3.62C13.67 3.48 14.54 3 16 3c1.46 0 2.33.45 2.97 1.25.64.8 1.03 2.06 1.03 3.66V9h3V7.9c0-2.09-.53-4.04-1.72-5.53A6.62 6.62 0 0 0 16 0zM9 10a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V13a3 3 0 0 0-3-3zm7 5a2 2 0 0 1 1 3.72V21a1 1 0 0 1-2 0v-2.28A2 2 0 0 1 16 15z" /></svg>;
});


// WEBPACK FOOTER //
// ./media/svg/icon-lock.svg